module.exports = __webpack_public_path__ + "static/assets/cd6b5a6158a14e37dd04cd251ce7450f.png";